import { withStyles } from '@material-ui/core';
import { RadioGroupWithLabel } from '../../Dispatch/RouteExecution/DriverPopUp/common/RadioGroup';
const styles = (theme) => ({
  detailsColumnWise: {
    display: 'Grid',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    alignItems: 'center'
  },
  updateErrorMessage: {
    color: theme.errorBorderColor,
    fontSize: theme.textFontSize,
    display: 'flex',
    alignItems: 'center',
    padding: '2px 0px'
  }
});
const UpdateProStatusOptions = ({
  updateStatus,
  setUpdatedProStatus,
  disableUpdate,
  shipmentStatus,
  classes,
  error
}) => {
  return (
    <div>
      <RadioGroupWithLabel
        customClasses={{ detailsColumnWise: classes.detailsColumnWise }}
        rowLabel="UPDATE STATUS"
        rowDescription=""
        options={[
          {
            value: 'isDelivered',
            labelText: 'Delivered',
            isDisabled: disableUpdate
          },
          {
            value: 'isDeleted',
            labelText: 'Deleted',
            isDisabled: disableUpdate
          }
        ]}
        value={updateStatus}
        onChange={setUpdatedProStatus}
      />
      {disableUpdate && (
        <span className={classes.updateErrorMessage}>{`Pro already ${shipmentStatus}`}</span>
      )}
      {Boolean(error) && <span className={classes.updateErrorMessage}>{error}</span>}
    </div>
  );
};
export default withStyles(styles)(UpdateProStatusOptions);
